// extracted by mini-css-extract-plugin
module.exports = {"linksSection":"we-z"};